import React from 'react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { 
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter 
} from '../../ui/dialog';
import { Edit, Loader2, Check } from 'lucide-react';

export default function ModalEditarQuantidade({
  open,
  onOpenChange,
  lote,
  novaQuantidade,
  setNovaQuantidade,
  salvandoQuantidade,
  onConfirm
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Edit className="h-5 w-5 text-blue-600" />
            Editar Quantidade
          </DialogTitle>
          <DialogDescription>
            Lote {lote?.codigo_lote || `L${lote?.numero_lote}`}
          </DialogDescription>
        </DialogHeader>
        
        <div className="py-4 space-y-4">
          <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg text-sm">
            <p className="text-amber-700">
              <strong>Atenção:</strong> Só é possível editar a quantidade enquanto nenhuma operação foi iniciada neste lote.
            </p>
          </div>
          
          <div>
            <label className="text-sm font-medium text-stone-700 block mb-1">
              Quantidade atual
            </label>
            <p className="text-lg font-semibold">{lote?.quantidade || 0} peças</p>
          </div>
          
          <div>
            <label className="text-sm font-medium text-stone-700 block mb-1">
              Nova quantidade
            </label>
            <Input
              type="number"
              min="1"
              value={novaQuantidade}
              onChange={(e) => setNovaQuantidade(e.target.value)}
              placeholder="Digite a nova quantidade"
              className="text-lg"
              data-testid="input-nova-quantidade"
            />
          </div>
        </div>
        
        <DialogFooter>
          <Button 
            variant="outline" 
            onClick={() => onOpenChange(false)}
          >
            Cancelar
          </Button>
          <Button 
            onClick={onConfirm}
            disabled={salvandoQuantidade || !novaQuantidade}
            className="bg-blue-600 hover:bg-blue-700"
          >
            {salvandoQuantidade ? (
              <Loader2 className="h-4 w-4 mr-2 animate-spin" />
            ) : (
              <Check className="h-4 w-4 mr-2" />
            )}
            Guardar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
